import { AddEditBatchClearingEntry, AddEditProductionPlanningEntry, DeleteBatchCLearingEntryById, DeleteProductionPlanningEntryById, GetAllBatchClearedRecords, GetAllJobChargeRecords, GetAllMaterialRequirementReportForPM, GetAllMaterialRequirementReportForRM, GetAllPendingProductionPlanningReport, GetAllProductionBatchRegister, GetAllProductionPlanningEntry, GetBatchClearingEntryByProductId, GetBatchCostingReportPMFormulaById, GetBatchCostingReportRMFormulaId, GetPMFormulaByPackingItemId, GetProductCostingReport, GetProductDetailsForBatchClearedByProductId, GetProductionPlanningEntryById, GetProductionPMFOrmulaByProductionDetailsId, GetProductionRMFOrmulaByProductionDetailsId, GetRMFormulaForProductionById, PackingRequisitionPMFormulaListing, ProductionRequisitionRMFormulaListing, RemoveProductionPlanningEntryFromBatchCLearingEntryById, RemoveProductionPlanningEntryFromPackingRequisition, RemoveProductionPlanningEntryFromProductionRequisition } from "../ApiEndPoints.js";
import { axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class ProductionServices {

    // Raw Material
    async addEditProductionPlanningEntry(request) {
        return axiosPostWithencryption(AddEditProductionPlanningEntry, request);
    }

    async getAllProductionPlanningEntry(request) {
        return axiosPostWithencryption(GetAllProductionPlanningEntry, request);
    }

    async getProductionPlanningEntryById(request) {
        return axiosGetWithencryption(GetProductionPlanningEntryById, request);
    }

    async deleteProductionPlanningEntryById(request) {
        return axiosGetWithencryption(DeleteProductionPlanningEntryById, request);
    }

    async getRMFormulaForProductionById(request) {
        return axiosGetWithencryption(GetRMFormulaForProductionById, request);
    }

    async productionRequisitionRMFormulaListing(request) {
        return axiosPostWithencryption(ProductionRequisitionRMFormulaListing, request);
    }

    async getProductionRMFOrmulaByProductionDetailsId(request) {
        return axiosGetWithencryption(GetProductionRMFOrmulaByProductionDetailsId, request);
    }

    async removeProductionPlanningEntryFromProductionRequisition(request) {
        return axiosGetWithencryption(RemoveProductionPlanningEntryFromProductionRequisition, request);
    }

    // Packing Requisition
    async getPMFormulaByPackingItemId(request) {
        return axiosGetWithencryption(GetPMFormulaByPackingItemId, request);
    }

    async packingRequisitionPMFormulaListing(request) {
        return axiosPostWithencryption(PackingRequisitionPMFormulaListing, request);
    }

    async getProductionPMFOrmulaByProductionDetailsId(request) {
        return axiosGetWithencryption(GetProductionPMFOrmulaByProductionDetailsId, request);
    }

    async removeProductionPlanningEntryFromPackingRequisition(request) {
        return axiosGetWithencryption(RemoveProductionPlanningEntryFromPackingRequisition, request);
    }

    // Batch Clearing
    async addEditBatchClearingEntry(request) {
        return axiosPostWithencryption(AddEditBatchClearingEntry, request);
    }

    async getBatchClearingEntryByProductId(request) {
        return axiosGetWithencryption(GetBatchClearingEntryByProductId, request);
    }

    async getAllBatchClearedRecords(request) {
        return axiosPostWithencryption(GetAllBatchClearedRecords, request);
    }

    async deleteBatchCLearingEntryById(request) {
        return axiosPostWithencryption(DeleteBatchCLearingEntryById, request);
    }

    async removeProductionPlanningEntryFromBatchCLearingEntryById(request) {
        return axiosGetWithencryption(RemoveProductionPlanningEntryFromBatchCLearingEntryById, request);
    }

    // Reports
    async getAllPendingProductionPlanningReport(request) {
        return axiosPostWithencryption(GetAllPendingProductionPlanningReport, request);
    }

    async getAllProductionBatchRegister(request) {
        return axiosPostWithencryption(GetAllProductionBatchRegister, request);
    }

    async getAllJobChargeRecords(request) {
        return axiosPostWithencryption(GetAllJobChargeRecords, request);
    }

    async getProductCostingReport(request) {
        return axiosPostWithencryption(GetProductCostingReport, request);
    }

    async getProductDetailsForBatchClearedByProductId(request) {
        return axiosGetWithencryption(GetProductDetailsForBatchClearedByProductId, request);
    }

    async getBatchCostingReportRMFormulaId(request) {
        return axiosGetWithencryption(GetBatchCostingReportRMFormulaId, request);
    }

    async getBatchCostingReportPMFormulaById(request) {
        return axiosGetWithencryption(GetBatchCostingReportPMFormulaById, request);
    }

    async getAllMaterialRequirementReportForRM(request) {
        return axiosPostWithencryption(GetAllMaterialRequirementReportForRM, request);
    }

    async getAllMaterialRequirementReportForPM(request) {
        return axiosPostWithencryption(GetAllMaterialRequirementReportForPM, request);
    }
}

